<template>
  <div class="SearchKnowledge">
    <el-select
      style="width: 90%"
      v-model="value"
      filterable
      remote
      reserve-keyword
      placeholder=""
      :remote-method="remoteMethod"
      :loading="loading"
      v-scroll="loadMore"
      @change="handleSelect"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button type="primary" @click="handleSearch">搜索</el-button>
    <MatchContentModal :searchVal="value"></MatchContentModal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import MatchContentModal from "@/pages/MyOutLine/MatchContentModal.vue";

export default {
  name: "SearchKnowledge",
  components: { MatchContentModal },
  data() {
    return {
      options: [],
      value: "",
      loading: false,
      list: [],
      query: "",
    };
  },
  computed: {
    ...mapState("courseCenter", ["matchTitleList"]),
  },
  methods: {
    ...mapActions("courseCenter", ["getMatchTitle"]),
    ...mapMutations("courseCenter", ["setData"]),
    handleSearch() {
      this.setData({
        key: "matchContentModalVisible",
        value: true,
      });
    },
    handleSelect(val) {
      this.value = val;
      this.setData({
        key: "matchContentModalVisible",
        value: true,
      });
    },
    async remoteMethod(query) {
      this.query = query;
      this.value = query;
      if (query !== "") {
        this.loading = true;
        await this.getMatchTitle({
          title: query,
        });
        this.list = this.matchTitleList.data.map((item) => {
          return { value: item, label: item };
        });
        setTimeout(() => {
          this.loading = false;
          this.options = this.list;
        }, 200);
      } else {
        this.options = [];
      }
    },
    async loadMore() {
      const currentPage = this.matchTitleList.page;
      const currentSize = this.matchTitleList.size;
      const currentTotal = this.matchTitleList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getMatchTitle({
          title: this.query,
          page: this.matchTitleList.page + 1,
        });
        this.list = this.list.concat(
          this.matchTitleList.data.map((item) => {
            return { value: item, label: item };
          })
        );
        setTimeout(() => {
          this.loading = false;
          this.options = this.list;
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.SearchKnowledge {
  margin-bottom: 20px;
}
</style>
